var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form",
    { ref: "form", attrs: { "label-width": "160px", size: "medium" } },
    [
      _c(
        "el-table",
        {
          staticClass: "form-table",
          attrs: { size: "medium", data: _vm.list, "show-header": false },
        },
        [
          _c("el-table-column", {
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-form-item",
                      { attrs: { label: row.title } },
                      [
                        _c(
                          "el-input",
                          {
                            attrs: {
                              type: "number",
                              placeholder: `请输入${row.title}`,
                            },
                            model: {
                              value: row.value,
                              callback: function ($$v) {
                                _vm.$set(row, "value", $$v)
                              },
                              expression: "row.value",
                            },
                          },
                          [
                            row.name == "blindNumber"
                              ? _c(
                                  "span",
                                  { attrs: { slot: "append" }, slot: "append" },
                                  [_vm._v("单")]
                                )
                              : row.name == "blindOrder"
                              ? _c(
                                  "span",
                                  { attrs: { slot: "append" }, slot: "append" },
                                  [_vm._v("单")]
                                )
                              : row.name == "blindAmount"
                              ? _c(
                                  "span",
                                  { attrs: { slot: "append" }, slot: "append" },
                                  [_vm._v("元")]
                                )
                              : _c(
                                  "span",
                                  { attrs: { slot: "append" }, slot: "append" },
                                  [_vm._v("%")]
                                ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm.list && _vm.list.length
        ? _c(
            "el-form-item",
            {
              staticStyle: { "margin-top": "22px" },
              attrs: { "label-width": "170px" },
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                [_vm._v("提交保存")]
              ),
              _c("el-button", [_vm._v("取消")]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }